import { createApp } from 'vue';
// global css
import 'virtual:uno.css';
import '@/assets/styles/index.scss';
import 'element-plus/theme-chalk/dark/css-vars.css';

// App、router、store
import App from './App.vue';
import store from './store';
import router from './router';

// 自定义指令
import directive from './directive';

// 注册插件
import plugins from './plugins/index'; // plugins

// 高亮组件
// import 'highlight.js/styles/a11y-light.css';
import 'highlight.js/styles/atom-one-dark.css';
import 'highlight.js/lib/common';
import HighLight from '@highlightjs/vue-plugin';

// svg图标
import 'virtual:svg-icons-register';
import ElementIcons from '@/plugins/svgicon';

// permission control
import './permission';

// 国际化
import i18n from '@/lang/index';

// vxeTable
import VXETable from 'vxe-table';
import 'vxe-table/lib/style.css';
VXETable.config({
  zIndex: 999999
});

// 修改 el-dialog 默认点击遮照为不关闭
import { ElDialog } from 'element-plus';
ElDialog.props.closeOnClickModal.default = false;

// Ueditor
import VueUeditorWrap from 'vue-ueditor-wrap';
// 或者
//const VueUeditorWrap = require('vue-ueditor-wrap'); // CommonJS

// 全局配置：忽略 Element Plus 的类型检查警告
const originalWarn = console.warn;
console.warn = function (...args) {
  // 过滤 Element Plus 的 type check failed 警告
  if (args[0] && typeof args[0] === 'string' && args[0].includes('type check failed for prop')) {
    return;
  }
  // 过滤 invalid prop 警告
  if (args[0] && typeof args[0] === 'string' && args[0].includes('Invalid prop:')) {
    return;
  }
  // 其他警告正常输出
  return originalWarn.apply(console, args);
};

const app = createApp(App);

app.use(HighLight);
app.use(ElementIcons);
app.use(router);
app.use(store);
app.use(i18n);
app.use(VXETable);
app.use(plugins);
app.use(VueUeditorWrap);
// 自定义指令
directive(app);

app.mount('#app');
